import { initBiPoint } from '@plugins/biPoint';
import {
  isCreditPayPointScriptCompatible,
  isV0PointScriptCompatible,
  isV1PointScriptCompatible,
  isV2PointScriptCompatible,
  isV35PointScriptCompatible,
  isV3PointScriptCompatible,
} from './checkPoint';

/**
 * 脚本版本 < 页面所需版本（含旧脚本无标识）时，由页面补 session。
 * 各版本监听是否挂载见 index.js，避免 import 副作用双挂。
 */
const ensurePointFallback = ({
  isCompatible,
  dataLayerName,
  needInitCommonParams = true,
}) => {
  if (isCompatible()) {
    return;
  }
  initBiPoint({ dataLayerName, needInitCommonParams });
};

export const ensureV35PointFallback = () =>
  ensurePointFallback({
    isCompatible: isV35PointScriptCompatible,
    dataLayerName: 'webstorev35DataLayer',
  });

export const ensureV3PointFallback = () =>
  ensurePointFallback({
    isCompatible: isV3PointScriptCompatible,
    dataLayerName: 'webstorev3DataLayer',
  });

export const ensureV2PointFallback = () =>
  ensurePointFallback({
    isCompatible: isV2PointScriptCompatible,
    dataLayerName: 'webstorev2DataLayer',
  });

export const ensureV1PointFallback = () =>
  ensurePointFallback({
    isCompatible: isV1PointScriptCompatible,
    dataLayerName: 'webstorev1DataLayer',
  });

export const ensureV0PointFallback = () =>
  ensurePointFallback({
    isCompatible: isV0PointScriptCompatible,
    dataLayerName: 'sdkstoreDataLayer',
  });

export const ensureCreditPayPointFallback = () =>
  ensurePointFallback({
    isCompatible: isCreditPayPointScriptCompatible,
    dataLayerName: 'creditPayDataLayer',
    needInitCommonParams: false,
  });
